import { Component, OnInit, ViewChild, inject } from '@angular/core';
import {TranslationService} from '../../core/services/translation.service';
import {LoginComponent} from '../../core/components/login/login.component';
import {ConfigService} from "../../core/services/config.service";
import {LoginService} from "../../core/components/login/login.service";
import {CssPropertiesEnum} from "../../core/models/css-properties.enum";
import {VHostService} from "../../core/services/v-host.service";
import {RedirectService} from "../../data/services/redirect.service";
import {Router, RouterLink} from "@angular/router";
import {LandingPageService} from "../../data/services/landing-page.service";
import {LandingPage} from "../../data/models/landing-page.model";
import {NgForOf, NgOptimizedImage} from '@angular/common';
import {CssPropertyPipe} from "../../core/pipes/css-property.pipe";
import {MatCard, MatCardContent, MatCardHeader, MatCardImage, MatCardTitle} from "@angular/material/card";
import {ToSafeHtmlPipe} from "../../core/pipes/to-safe-html.pipe";
import {Image} from "../../data/models/image";
import {ImageHandler} from "../../core/services/image-handler.service";
import {ImageService} from '../../core/services/image.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  imports: [
    MatCard,
    RouterLink,
    MatCardHeader,
    LoginComponent,
    MatCardImage,
    MatCardContent,
    NgForOf,
    MatCardTitle,
    ToSafeHtmlPipe,
    NgOptimizedImage
  ],
  standalone: true
})
export class LandingPageComponent implements OnInit {
  translationService = inject(TranslationService);
  configService = inject(ConfigService);
  loginService = inject(LoginService);
  redirectService = inject(RedirectService);
  router = inject(Router);
  vHostService = inject(VHostService);
  landingPageService = inject(LandingPageService);
  imageHandler: ImageHandler = inject(ImageHandler);
  imageService = inject(ImageService);

  cards: { title: string, image: Image, description: string, route: string, isLogIn: boolean, extern: boolean }[] = [];

  cssPropertyPipe = new CssPropertyPipe();

  @ViewChild('login') loginComponent: LoginComponent;
  isAuthenticated: boolean = false;
  CssPropertiesEnum = CssPropertiesEnum;
  pages: LandingPage[];
  actualPage: LandingPage;
  constructor() {
    this.loginService.getAuthData().subscribe((authData) => {
      this.isAuthenticated = !!authData;
      this.buildCards();
    });

    this.landingPageService.getLandingPages().subscribe(pages => {
      if(pages && pages.length > 0) {
        this.pages = pages;
        this.buildCards();
      }
    })
  }

  buildCards(): void {
    this.cards = [];
    this.pages?.forEach( page => {
      if (page.showOnLandingpage) {
        if ((page.showAfterLogin && this.isAuthenticated) || (page.showBeforeLogin && !this.isAuthenticated)) {
          this.cards.push({
            title: page.description,
            image: this.imageHandler.addAltText(page.file, page.description ?? this.translationService.getTranslation('landingPage.image.altText.default')),
            description: page.extendedDescription,
            route: page.link !== 'login' ? (page.isExtern ? page.externLink : page.link) : null,
            extern: page.isExtern,
            isLogIn: page.link === 'login'
          })
        }
      }
    });
  }

  ngOnInit(): void {
    const url = this.router.url.split('/')[1];
    this.landingPageService.getPageOfUrl(url).subscribe(page => {
      this.actualPage = page;
    });
  }

  onClickEvent(): void {
    this.loginComponent.onClickEvent();
  }

  onImgError(event, imgPath): void {
    event.target.src = imgPath;
  }

  navigateToRoute(card) {
    if (card.extern) {
      this.redirectService.redirect(card.route, true);
    } else {
      this.router.navigate([card.route], {queryParamsHandling: "preserve"});
    }
  }

  hasCustomResponsivClasses() {
    return !!this.getCustomResponsivClasses();
  }

  getCustomResponsivClasses() {
    const t = this.cssPropertyPipe.transform;

    const classes = [
      'col-' + t(CssPropertiesEnum.landingFxFlex, this.vHostService),
      'col-sm-' + t(CssPropertiesEnum.landingFxFlexSM, this.vHostService),
      'col-md-' + t(CssPropertiesEnum.landingFxFlexMD, this.vHostService),
      'col-lg-' + t(CssPropertiesEnum.landingFxFlexLG, this.vHostService),
      'col-xl-' + t(CssPropertiesEnum.landingFxFlexXL, this.vHostService),
      'col-xxl-' + t(CssPropertiesEnum.landingFxFlexXXL, this.vHostService)
    ].join(' ');

    return /\d/.test(classes) ? classes : '';
  }
}
